module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"dashboard":{"title":"Dashboard","totls":"Totais","last_12_months":"Últimos 12 meses","tickets_this_month":"Tickets este mês"},"Services":"Serviços"},"en":{"dashboard":{"title":"Dashboard","totls":"Totals","last_12_months":"Last 12 months","tickets_this_month":"Tickets this month"},"Services":"Services"}}')
  delete Component.options._Ctor
}
